import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { DocumentWithDownloadUrl as Document } from '@/client';
import { ENABLE_CORRECTIONS_DISPLAY_FEATURE } from '@/config/featureFlags';
import { getDocumentCorrections } from '@/utils/documentUtils';
import { pluralize } from '@/utils/dateUtils';
import CorrectionListItem from '@/components/documents/CorrectionListItem';

interface RecordCorrectionsSectionProps {
	document: Document;
}

/**
 * The corrections saved against one record, in the drawer that has room for their text — the list
 * row only carries a count (see RecordCorrectionsBadge).
 *
 * Reads the corrections off the document itself; the documents list already carries them, so opening
 * a record costs no extra request. Gated here rather than at the call site, same as the badge.
 */
const RecordCorrectionsSection: React.FC<RecordCorrectionsSectionProps> = (props: RecordCorrectionsSectionProps) => {
	const { document } = props;
	const corrections = getDocumentCorrections(document);

	if (!ENABLE_CORRECTIONS_DISPLAY_FEATURE || corrections.length === 0) return null;

	return (
		<VStack align="stretch" gap={3} w="full">
			<Text textStyle="body.strong" lineHeight="1.5">
				{pluralize(corrections.length, 'correction')}
			</Text>
			{corrections.map((correction) => (
				<CorrectionListItem key={correction.id} correction={correction} />
			))}
		</VStack>
	);
};

export default RecordCorrectionsSection;
